import React, { ComponentPropsWithoutRef } from 'react';

import PropTypes from 'prop-types';

import Animation from '@adsk/alloy-react-animation';
import { useKeyEvent } from '@adsk/alloy-react-helpers';
import theme, { stylePropType } from '@adsk/alloy-react-theme';

type Props = ComponentPropsWithoutRef<typeof Animation> & {
  hide?: boolean;
  onEscape?: (e: KeyboardEvent) => void;
};

const ESCAPE = 'Escape';
const Overlay = ({
  style,
  className,
  children,
  hide,
  onClick,
  onEscape,
  onAnimationStart,
  onAnimationComplete,
  initial = { opacity: 0 },
  animate = { opacity: 1 },
  exit = { opacity: 0 },
  ...props
}: Props) => {
  useKeyEvent(ESCAPE, { onKeyDown: onEscape });

  return (
    <Animation
      key="modal"
      initial={initial}
      animate={animate}
      exit={exit}
      className={className}
      onClick={onClick}
      onAnimationStart={onAnimationStart}
      onAnimationComplete={onAnimationComplete}
      {...props}
      style={[
        {
          position: 'fixed',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: theme.colors.darkBlue900Alpha45,
          bottom: 0,
          left: 0,
          right: 0,
          top: 0,

          zIndex: theme.zIndex.overlay,
          ...(hide && {
            background: 'transparent',
            pointerEvents: 'none',
          }),
        },
        style,
      ]}
    >
      {children}
    </Animation>
  );
};

Overlay.propTypes = {
  /** The content of the overlay */
  children: PropTypes.any,
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** hide overlay  */
  hide: PropTypes.bool,
  /** handle onclick event for Overlay */
  onClick: PropTypes.func,
  /** called when motion.div Animation Complete and overlay closed */
  onAnimationComplete: PropTypes.func,
  /** called when motion.div Animation Starts and overlay open */
  onAnimationStart: PropTypes.func,
};

export default Overlay;
